'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemsHelper = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _galleryItem = require('../item/galleryItem');

var _galleryItem2 = _interopRequireDefault(_galleryItem);

var _galleryGroup = require('../group/galleryGroup');

var _galleryGroup2 = _interopRequireDefault(_galleryGroup);

var _utils = require('../../utils');

var _utils2 = _interopRequireDefault(_utils);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemsHelper = exports.ItemsHelper = function () {
  function ItemsHelper() {
    (0, _classCallCheck3.default)(this, ItemsHelper);
  }

  (0, _createClass3.default)(ItemsHelper, null, [{
    key: 'convertDtoToLayoutItem',
    value: function convertDtoToLayoutItem(dto) {
      var isLayoutItem = !!(dto.id && dto.width > 0 && dto.height > 0);
      if (isLayoutItem) {
        return dto;
      } else {
        var dtoMetadata = dto.metadata || dto.metaData;
        var metadata = _lodash2.default.isObject(dtoMetadata) ? dtoMetadata : _utils2.default.parseStringObject(dtoMetadata) || {};
        return (0, _extends3.default)({
          id: dto.itemId || dto.photoId,
          width: metadata.width,
          height: metadata.height
        }, dto);
      }
    }
  }, {
    key: 'convertToGalleryItems',
    value: function convertToGalleryItems(galleryStructure) {
      var itemConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pointer = 0;
      galleryStructure.galleryItems = [];
      for (var c = 0; c < galleryStructure.columns.length; c++) {
        var column = galleryStructure.columns[c];
        column.galleryGroups = [];
        var groups = column.groups || column;
        for (var g = 0; g < groups.length; g++) {
          var group = groups[g];
          var groupItems = [];
          for (var i = 0; i < group.items.length; i++) {
            var item = group.items[i];
            groupItems[i] = new _galleryItem2.default((0, _assign2.default)({
              scheme: item,
              dto: item.dto
            }, itemConfig));
            galleryStructure.galleryItems[item.idx] = groupItems[i];
            pointer++;
          }
          column.galleryGroups[g] = new _galleryGroup2.default({
            scheme: group,
            dto: group.dto,
            items: groupItems
          });
        }
      }
      if (_utils2.default.isVerbose()) {
        console.log({ galleryStructure: galleryStructure });
      }

      return galleryStructure;
    }
  }, {
    key: 'convertExistingStructureToGalleryItems',
    value: function convertExistingStructureToGalleryItems(existingStructure, galleryStructure) {
      var itemConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // console.log('convertToGalleryItems', existingStructure.galleryItems);
      // console.count('convertToGalleryItems');
      if (_utils2.default.isVerbose()) {
        console.time('convertToGalleryItems');
      }
      if (!existingStructure.galleryItems) {
        existingStructure.galleryItems = [];
      }
      for (var c = 0; c < galleryStructure.columns.length; c++) {
        var column = galleryStructure.columns[c];
        var existingColumn = existingStructure.columns[c] || column;
        if (!existingColumn.galleryGroups) {
          existingColumn.galleryGroups = [];
        }
        var groups = column.groups || column;
        for (var g = 0; g < groups.length; g++) {
          var group = groups[g];
          var groupItems = [];
          for (var i = 0; i < group.items.length; i++) {
            var item = group.items[i];
            if (!existingStructure.galleryItems[item.idx]) {
              // console.count(`convertToGalleryItems - item [${item.idx}]`);
              groupItems[i] = new _galleryItem2.default((0, _assign2.default)({
                scheme: item,
                dto: item.dto
              }, itemConfig));
              existingStructure.galleryItems[item.idx] = groupItems[i];
            } else {
              existingStructure.galleryItems[item.idx].processScheme(item);
            }
          }
          if (!existingColumn.galleryGroups[g]) {
            // console.count(`convertToGalleryItems - group [${g}]`);
            existingColumn.galleryGroups[g] = new _galleryGroup2.default({
              scheme: group,
              dto: group.dto,
              items: groupItems
            });
          } else {
            existingColumn.galleryGroups[g].processScheme(group);
          }
        }
        column.galleryGroups = existingColumn.galleryGroups;
      }
      galleryStructure.galleryItems = existingStructure.galleryItems;
      if (_utils2.default.isVerbose()) {
        console.timeEnd('convertToGalleryItems');
      }
      return galleryStructure;
    }
  }]);
  return ItemsHelper;
}();